export default {
  path: 'spl-company/:idElement',
  name: 'SicuraSolutionMySplCompany',
  component: () => import('@/views/private/MySplCompany.vue'),
  props: true,
  children: [
    {
      path: 'anagrafica',
      name: 'SicuraSolutionMySplCompanyAnagrafica',
      component: () => import('@/components/my-spl-company/Anagrafica.vue'),
    },
    {
      path: 'contatti',
      name: 'SicuraSolutionMySplCompanyContatti',
      component: () => import('@/components/my-spl-company/Contatti.vue'),
    },
    {
      path: 'servizi',
      name: 'SicuraSolutionMySplCompanyServizi',
      component: () => import('@/components/my-spl-company/Servizi.vue'),
    },
    {
      path: 'info',
      name: 'SicuraSolutionMySplCompanyInfo',
      component: () => import('@/components/my-spl-company/Info.vue'),
    },
    {
      path: 'locations',
      name: 'SicuraSolutionMySplCompanyLocations',
      component: () => import('@/components/my-spl-company/Locations.vue'),
      children: [
        {
          path: ':id?',
          name: 'SicuraSolutionMySplCompanyLocationsEdit',
          component: () => import('@/components/my-spl-company/locations/EditForm.vue'),
        },
        {
          path: 'new',
          name: 'SicuraSolutionMySplCompanyLocationsNew',
          component: () => import('@/components/my-spl-company/locations/NewForm.vue'),
        },
      ],
    },
    {
      path: 'funzionalita-aggiuntive',
      name: 'SicuraSolutionMySplCompanyFunzionalitaAggiuntive',
      component: () => import('@/components/my-spl-company/FunzionalitaAggiuntive.vue'),
    },
  ],
};
